import {call, delay, put, takeLatest} from 'redux-saga/effects'
import {ParamsModel} from 'src/app/modules/common/Model'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {actions} from './action'
import {actionTypes} from './constants'
import {service} from './service'

function* getAuditTrailSaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload

    yield delay(300)
    const response: ResponseModel = yield call(service.getAuditTrail, params)
    yield put(actions.getAuditTrailSuccess(response?.data?.data))
    yield put(actions.getAuditTrailFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.getAuditTrailFinish())
  }
}

function* getAuditTrailFilterOptionsSaga() {
  try {
    const response: ResponseModel = yield call(service.getAuditTrailFilterOptions)
    yield put(actions.getAuditTrailFilterOptionsSuccess(response?.data?.data))
    yield put(actions.getAuditTrailFilterOptionsFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({
        type: globalActionTypes.GLOBAL_ERROR,
        payload: err.response.data.message,
      })
    }
    yield put(actions.getAuditTrailFilterOptionsFinish())
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_AUDIT_TRAIL_START, getAuditTrailSaga)
  yield takeLatest(actionTypes.GET_AUDIT_TRAIL_FILTER_OPTIONS_START, getAuditTrailFilterOptionsSaga)
}
